import { zeroFormat } from 'numeral';
import React from 'react';

const GetHelp = (props) => {
    let imageUrl = props.app.config.assetsUrl + props.app.config.imageUrl;

    return (
        <div className="get-help-wrapper">
            <div className="get-help-display">
                <div className="help-image">
                    <img src={`${imageUrl}/misc/support-bubble.svg`}/>
                </div>
                <div className="help-title">
                    Let us help!
                </div>
                <div className="help-copy">
                    Our support team is here to help you resolve any issues you are having.
                </div>
                <div className="help-button-cancellation" role="button" onClick={(e) => {
                    zE.identify({
                        email: props.user.detail.email
                    });
                    zE.activate();
                }}>
                    Open a priority ticket
                </div>
                <div className="cancel-advance">
                    <div className="no-thanks-link" onClick={(e) => {
                        props.advance(3)
                    }}>
                        No thanks
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GetHelp;
